export const formatRatioWithFourDigits = (
  value: number | null | undefined,
  language: string,
  emptyState: React.ReactElement
): React.ReactElement | string => {
  if (value === null || value === undefined || value === 0) {
    return emptyState;
  }

  const formatted = new Intl.NumberFormat(`${language}-CA`, {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4
  }).format(Number(value));
  return `${formatted} %`;
};
